<template>
  <div class="home-banner-section">
    <div class="home-banner-container">
      <div class="home-banner-grid">
        <a
          v-for="banner in activeBanners"
          :key="banner.id"
          :href="banner.link || '#'"
          class="home-banner-item"
        >
          <img
            v-if="banner.image"
            :src="banner.image"
            :alt="banner.title"
            class="home-banner-image"
            width="600"
            height="300"
            loading="lazy"
            @error="$event.target.style.display='none'"
          />
          <div v-if="!banner.image" class="home-banner-placeholder">
            {{ banner.title || 'Banner' }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  banners: {
    type: Array,
    default: () => []
  }
})

const fallbackBanners = [
  { id: 'fallback-1', title: 'Banner', image: '1.webp', link: '#' }
]

const activeBanners = computed(() => {
  return props.banners && props.banners.length > 0 ? props.banners : fallbackBanners
})
</script>
